"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldForceFunctionUrlForService = exports.isSellerEnabledInPercentageRollout = exports.isSellerConfiguredAsV2InSSM = exports.getSSMConfigForTargetAPI = exports.isSSMConfigPresentForTargetAPI = exports.resetSSMConfigCache = void 0;
const splitio_segments_1 = require("./splitio-segments");
const TargetAPISellerSSMConfig_1 = require("./TargetAPISellerSSMConfig");
const commons_logs_1 = require("@deliverr/commons-logs");
const ParserUtils_1 = require("@deliverr/commons-utils/lib/ParserUtils");
const InboundTargetSellersInPriority_1 = require("./splitio-segments/InboundTargetSellersInPriority");
let cachedSSMConfig = null;
function resetSSMConfigCache() {
    cachedSSMConfig = null;
}
exports.resetSSMConfigCache = resetSSMConfigCache;
function isSSMConfigPresentForTargetAPI() {
    try {
        return Boolean(process.env.INBOUND_SERVICE_TARGET_API_SELLER_CONFIG);
    }
    catch (e) {
        return false;
    }
}
exports.isSSMConfigPresentForTargetAPI = isSSMConfigPresentForTargetAPI;
function getSSMConfigForTargetAPI() {
    if (cachedSSMConfig === null) {
        try {
            cachedSSMConfig = isSSMConfigPresentForTargetAPI()
                ? (0, ParserUtils_1.json)(process.env.INBOUND_SERVICE_TARGET_API_SELLER_CONFIG)
                : TargetAPISellerSSMConfig_1.TargetAPISellerSSMConfigDefaultValue;
        }
        catch (e) {
            commons_logs_1.log.warn("Error parsing SSM config", { error: e });
            cachedSSMConfig = TargetAPISellerSSMConfig_1.TargetAPISellerSSMConfigDefaultValue;
        }
    }
    return cachedSSMConfig;
}
exports.getSSMConfigForTargetAPI = getSSMConfigForTargetAPI;
function isSellerConfiguredAsV2InSSM(sellerId) {
    var _a, _b, _c, _d;
    try {
        const ssmConfigForTargetAPI = getSSMConfigForTargetAPI();
        const service = process.env.DD_SERVICE || process.env.SERVICE_NAME;
        if (service && ((_a = ssmConfigForTargetAPI.excluded_services) === null || _a === void 0 ? void 0 : _a.includes(service))) {
            return false;
        }
        if ((_b = ssmConfigForTargetAPI.disabled_users) === null || _b === void 0 ? void 0 : _b.includes(sellerId)) {
            return false;
        }
        if ((_c = ssmConfigForTargetAPI.enabled_users) === null || _c === void 0 ? void 0 : _c.includes(sellerId)) {
            return true;
        }
        if (ssmConfigForTargetAPI.rollout_percentage) {
            return isSellerEnabledInPercentageRollout(sellerId, ssmConfigForTargetAPI.rollout_percentage);
        }
        const segmentName = identifySellerSegment(sellerId);
        if (segmentName && ((_d = ssmConfigForTargetAPI.enabled_segments) === null || _d === void 0 ? void 0 : _d.includes(segmentName))) {
            return true;
        }
    }
    catch (e) {
        commons_logs_1.log.warn("Error determining if seller is V2", { sellerId, error: e });
    }
    return false;
}
exports.isSellerConfiguredAsV2InSSM = isSellerConfiguredAsV2InSSM;
function identifySellerSegment(sellerId) {
    for (const [segmentName, segmentKeys] of splitio_segments_1.SEGMENTS_MAP) {
        if (segmentKeys.has(sellerId)) {
            return segmentName;
        }
    }
    return undefined;
}
function isSellerEnabledInPercentageRollout(sellerId, rolloutPercent) {
    try {
        if (rolloutPercent <= 0) {
            return false;
        }
        if (rolloutPercent >= 100) {
            return true;
        }
        const totalSellers = InboundTargetSellersInPriority_1.inboundTargetSellerSorted.length;
        const segmentSize = Math.ceil((rolloutPercent / 100) * totalSellers);
        const sellerIndex = InboundTargetSellersInPriority_1.inboundTargetSellerSorted.indexOf(sellerId);
        return sellerIndex >= 0 && sellerIndex < segmentSize;
    }
    catch (e) {
        commons_logs_1.log.warn("Error determining if seller is enabled in percentage rollout", { sellerId, error: e });
    }
    return false;
}
exports.isSellerEnabledInPercentageRollout = isSellerEnabledInPercentageRollout;
function shouldForceFunctionUrlForService(service) {
    var _a;
    try {
        if (((_a = process.env.FORCE_LAMBDA_FUNCTION_URL) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "true") {
            return true;
        }
        const ssmConfigForTargetAPI = getSSMConfigForTargetAPI();
        service = service || process.env.DD_SERVICE || process.env.SERVICE_NAME || "default_service";
        service = service === null || service === void 0 ? void 0 : service.toLowerCase();
        const functionUrlServices = ssmConfigForTargetAPI.function_url_services || [];
        return functionUrlServices.some((functionUrlService) => functionUrlService.toLowerCase() === service);
    }
    catch (e) {
        commons_logs_1.log.warn("Error determining if service should force function url", { service, error: e });
    }
    return false;
}
exports.shouldForceFunctionUrlForService = shouldForceFunctionUrlForService;
//# sourceMappingURL=SSMFlagUtils.js.map